import Icon from '../components/Icon'

Icon.register({
  'handshake-slash': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M0 128.2h23.8l72.2 55.8v168c0 17.7-14.3 32-32 32h-64v-255.8zM48 320.1c-8.8 0-16 7.2-16 16 0 8.8 7.2 16 16 16s16-7.2 16-16c0-8.8-7.2-16-16-16zM128 351.9v-143.2l278 214.9-8.8 10.8c-6.8 8.4-17.2 13.7-28.9 13.7-8.9 0-17-3.1-23.4-8.3l-17.9-15.5-0.2 0.2c-11.7 14.4-29.7 23.6-49.7 23.6-15.3 0-29.3-5.4-40.3-14.3l-90.5-81.9h-18.3zM544 128.2h96v255.9h-64c-17.7 0-32-14.3-32-32v-223.9zM592 352.1c8.8 0 16-7.2 16-16 0-8.8-7.2-16-16-16s-16 7.2-16 16c0 8.8 7.2 16 16 16zM303.3 202.7l330.5 255.4c3.8 2.9 6.2 7.5 6.2 12.6 0 3.7-1.3 7.1-3.4 9.8l-19.7 25.3c-2.9 3.8-7.5 6.2-12.7 6.2-3.7 0-7.1-1.3-9.8-3.4l-588.3-454.7c-3.8-2.9-6.2-7.5-6.2-12.6 0-3.7 1.3-7.1 3.4-9.8l19.6-25.3c2.9-3.8 7.5-6.2 12.7-6.2 3.7 0 7.1 1.3 9.8 3.4l116.9 90.3 20.3-20.3c5.8-5.8 13.8-9.4 22.6-9.4h83.8l-75.6 69.2 25.6 19.8 88.1-80.6c5.7-5.2 13.3-8.4 21.6-8.4h0 85.9c0 0 0 0 0 0 8.8 0 16.8 3.6 22.6 9.4l54.6 54.6v193.5c-2.5-2.8-5.1-5.3-7.9-7.7l-145.6-118.2 26.1-23.9c3.1-2.9 5-7 5-11.6 0-8.8-7.2-16-16-16-4 0-7.7 1.5-10.5 4z'
      }
    ]
  }
})
